import NotificationDot from './NotificationDot';

export default NotificationDot;
